import { useCallback, useMemo, useState } from 'react'

export const useContentIsOpen = (
  isOpen: boolean | undefined
): [
  isOpen: boolean,
  onOpen: (id: symbol) => void,
  onClose: (id?: symbol) => void,
] => {
  const [state, setState] = useState(() => new Set<symbol>())
  const isOpenOrContentIsOpen = useMemo(
    () => isOpen || state.size > 0,
    [state, isOpen]
  )
  const onOpen = useCallback((id: symbol) => {
    setState(state => new Set(state).add(id))
  }, [])
  const onClose = useCallback((id?: symbol) => {
    if (!id) {
      setState(new Set())
    } else {
      setState(state => {
        const next = new Set(state)
        next.delete(id)
        return next
      })
    }
  }, [])
  return [isOpenOrContentIsOpen, onOpen, onClose]
}
